import { useConst } from './useConst'

export function useConstantId(prefix: string) {
  const uuid = Math.random().toString().split('.')[1]
  return useConst(`${prefix}${uuid}`)
}
